import React from 'react';

/**
 * Asked at a job phase that can email the client. Sending and skipping both
 * let the phase finish; only the email is optional.
 */
const ClientSendPrompt = ({
  title,
  detail,
  busy = false,
  onSend,
  onSkip,
}: {
  title: string;
  detail: string;
  busy?: boolean;
  onSend: () => void;
  onSkip: () => void;
}) => (
  <div className="studio-leave-backdrop" role="presentation">
    <div className="studio-leave-dialog" role="dialog" aria-modal="true" aria-labelledby="client-send-title" data-testid="client-send-prompt">
      <h3 id="client-send-title">{title}</h3>
      <p>{detail}</p>
      <div className="studio-toolbar">
        <button type="button" className="studio-primary" data-testid="client-send-yes" disabled={busy} onClick={onSend}>
          {busy ? 'Sending…' : 'Send to client'}
        </button>
        <button type="button" className="studio-secondary" data-testid="client-send-no" disabled={busy} onClick={onSkip}>
          Don't send
        </button>
      </div>
    </div>
  </div>
);

export default ClientSendPrompt;
